module.exports = __webpack_public_path__ + "static/media/0027_LES_STRUCTURES_GONDOLES.42fcf19e.webp";